export enum EndScheduleType {
  OnDate = "ondate",
  After = "after",
  Never = "never"
}
